import { Tabs } from "react-vant";
import styles from "./Textbook.module.less";
import AllTextbook from "views/textbook/all-textbook/AllTextbook";
const Textbook = () => {
  return (
    <div className={styles["textbook-container"]}>
      <Tabs
        ellipsis={false}
        className={styles["tab-container"]}
        defaultActive={0}
        type="line"
      >
        <Tabs.TabPane key={`course-tab-${1}`} title={"全部教材"}>
          <AllTextbook />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};
export default Textbook;
